import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import './AlertModelTwo.scss';
import { useLocation, useNavigate } from "react-router-dom";
const AlertModelTwo = (props) => {
    const navigate = useNavigate();
  return (
    <>
      <Modal
        show={props.isConfirm}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        onHide={() => props.handleClose(false)}
        centered
      >
        <Modal.Header onClick={() => props.handleClose(false)} closeButton></Modal.Header>
        <Modal.Body>
          <div className='confirm-modal-wrapper'>
            <h2 className='modal-title text-center'>{props.text}</h2>
            <div className='w-100 confirm-btn-wrapper'>
              <Button onClick={() =>  navigate("/consumer/jobs?tab=completed")} variant='outline-primary'>Pay</Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AlertModelTwo;
